import { Card } from "@/components/ui/card";
import { Sun, Moon, Sunrise, Sunset } from "lucide-react";
import SectionHeader from "./SectionHeader";

const TWELVE = [
  { icon: Sun, label: "Day Shift", time: "8:00 AM – 8:00 PM" },
  { icon: Moon, label: "Night Shift", time: "8:00 PM – 8:00 AM" },
];

const EIGHT = [
  { icon: Sunrise, label: "Morning", time: "8:00 AM – 4:00 PM" },
  { icon: Sunset, label: "Afternoon", time: "4:00 PM – 12:00 AM" },
  { icon: Moon, label: "Night", time: "12:00 AM – 8:00 AM" },
];

export default function ShiftModels() {
  return (
    <section
      className="bg-white py-16 md:py-24"
      data-testid="shift-models-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Shift Models"
          title="Workforce coverage built for your operating hours"
          description="We deploy in flexible shift configurations to match round-the-clock industrial requirements."
          testid="shift-models-header"
        />
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          <ShiftCard
            title="12 Hours · 2-Shift Model"
            shifts={TWELVE}
            highlight
            testid="shift-card-12hr"
          />
          <ShiftCard
            title="8 Hours · 3-Shift Model"
            shifts={EIGHT}
            testid="shift-card-8hr"
          />
        </div>
      </div>
    </section>
  );
}

function ShiftCard({ title, shifts, highlight = false, testid }) {
  return (
    <Card
      data-testid={testid}
      className={`relative p-6 sm:p-8 rounded-sm border bg-white rk-lift ${
        highlight ? "border-[#1F6B5C]/40" : "border-[#E2E8F0]"
      }`}
    >
      {highlight && (
        <span className="absolute -top-3 left-6 bg-[#1F6B5C] text-white text-[10px] font-bold tracking-widest uppercase px-2 py-1 rounded-sm">
          Most preferred
        </span>
      )}
      <h3 className="font-display text-xl sm:text-2xl font-bold text-[#0F172A]">
        {title}
      </h3>
      <div className="mt-6 space-y-3">
        {shifts.map((s) => {
          const Icon = s.icon;
          return (
            <div
              key={s.label}
              className="flex items-center justify-between gap-3 p-4 bg-[#F8FAFC] rounded-sm border border-[#E2E8F0]"
            >
              <div className="flex items-center gap-3">
                <div className="h-9 w-9 grid place-items-center rounded-sm bg-[#1E3A8A]/8 text-[#1E3A8A]">
                  <Icon className="h-4 w-4" />
                </div>
                <div className="font-semibold text-[#0F172A]">{s.label}</div>
              </div>
              <div className="font-mono text-sm font-semibold text-[#1F6B5C]">
                {s.time}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
